export const SENTRY_TAG_INSCALAR = 'inscalar'
